import React from "react";
import colors from "../../../colors/colors";
import { CategoryItem } from "../hooks/useEditPanelFields";

interface CategorySidebarProps {
  categoryList: CategoryItem[];
  activeCategory: string | null;
  setActiveCategory: (category: string | null) => void;
  searchMatchCounts: Record<string, number> | null;
}

export const CategorySidebar: React.FC<CategorySidebarProps> = ({
  categoryList,
  activeCategory,
  setActiveCategory,
  searchMatchCounts,
}) => (
  <div
    className="edit-panel-sidebar"
    style={{
      width: "160px",
      minWidth: "160px",
      borderRight: `1px solid ${colors.border_glass}`,
      overflowY: "auto",
      padding: "8px 0",
    }}
  >
    {categoryList.map((cat) => {
      const isActive =
        activeCategory === cat.key ||
        (!activeCategory && cat.key === "__all__");
      const matchCount = searchMatchCounts
        ? (searchMatchCounts[cat.key] ?? 0)
        : cat.count;
      const isDimmed = searchMatchCounts !== null && matchCount === 0;

      return (
        <button
          key={cat.key}
          className="edit-panel-sidebar-item"
          onClick={() =>
            setActiveCategory(
              isActive && cat.key !== "__all__" ? null : cat.key,
            )
          }
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            padding: "7px 16px 7px 20px",
            background: isActive ? "rgba(85, 114, 183, 0.1)" : "none",
            border: "none",
            borderLeft: isActive
              ? `3px solid ${colors.blue}`
              : "3px solid transparent",
            cursor: "pointer",
            fontSize: "11px",
            fontWeight: isActive ? 600 : 500,
            color: isActive ? colors.blue : colors.gray_medium,
            textAlign: "left",
            opacity: isDimmed ? 0.35 : 1,
            fontFamily: "inherit",
          }}
        >
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {cat.name}
          </span>
          <span
            style={{
              fontSize: "10px",
              fontWeight: 500,
              color: isActive ? colors.blue : colors.gray_border,
              marginLeft: "6px",
              flexShrink: 0,
            }}
          >
            {searchMatchCounts ? matchCount : cat.count}
          </span>
        </button>
      );
    })}
  </div>
);
